document.addEventListener("DOMContentLoaded", function () {
    // ------------------------------------------------
  // よくあるご質問
  // ------------------------------------------------
  const initializeAccordion = (details) => {
    const summary = details.querySelector("summary");
    const panel = details.querySelector("summary + *");

    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる
    let isTransitioning = false; // 連打防止フラグ

    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.gridTemplateRows = "0fr";
      details.setAttribute("open", "");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.gridTemplateRows = "1fr";
        });
      });
      panel.addEventListener(
        "transitionend",
        () => {
          isTransitioning = false;
        },
        { once: true }
      );
    };

    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.gridTemplateRows = "0fr";
      panel.addEventListener(
        "transitionend",
        () => {
          details.removeAttribute("open");
          panel.style.gridTemplateRows = "";
          isTransitioning = false;
        },
        { once: true }
      );
    };

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };

  const accordions = document.querySelectorAll(".vegetable_lp1-faq__item");
  accordions.forEach((details) => {
    initializeAccordion(details);
  });

  // ================================================
  // lp17-mv__lower-promotionがウィンドウ最上位に来たらjs-floatのopacityを1にする
  // ================================================
  // const mvLowerPromotion = document.querySelector('.vegetable_lp1-mv__lower-promotion');
  // const floatElement = document.getElementById('js-float');

  // if (mvLowerPromotion && floatElement) {
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       // 要素の下端がビューポートの上端に来た時（要素がビューポートから完全に外れた時）
  //       if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
  //         floatElement.style.opacity = '1';
  //         floatElement.style.visibility = 'visible';
  //       }
  //       // 要素がビューポート内に戻ってきた時（上位に戻った時）
  //       else if (entry.isIntersecting || entry.boundingClientRect.top >= 0) {
  //         floatElement.style.opacity = '0';
  //         floatElement.style.visibility = 'hidden';
  //       }
  //     });
  //   }, {
  //     root: null,
  //     rootMargin: '0px',
  //     threshold: 0
  //   });

  //   observer.observe(mvLowerPromotion);
  // }

  // ================================================
  // footerが見えたらjs-floatを消す
  // ================================================
  // const footerElement = document.querySelector('.vegetable_lp1-footer');
  
  // if (footerElement && floatElement && mvLowerPromotion) {
  //   const footerObserver = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       // footerがビューポートに入ったら（見えたら）opacityを0にする
  //       if (entry.isIntersecting) {
  //         floatElement.style.opacity = '0';
  //         floatElement.style.visibility = 'hidden';
  //       }
  //       // footerがビューポートから外れた時、lp17-mv__lower-promotionの状態をチェック
  //       else if (!entry.isIntersecting) {
  //         const mvRect = mvLowerPromotion.getBoundingClientRect();
  //         // lp17-mv__lower-promotionがビューポートから外れていれば再表示
  //         if (mvRect.top < 0) {
  //           floatElement.style.opacity = '1';
  //           floatElement.style.visibility = 'visible';
  //         }
  //       }
  //     });
  //   }, {
  //     root: null,
  //     rootMargin: '0px',
  //     threshold: 0
  //   });

  //   footerObserver.observe(footerElement);
  // }

});



  // ================================================
  // ローディング画面の表示
  // ================================================
document.addEventListener('DOMContentLoaded', () => {
  const loading = document.getElementById('loadingScreen');
  if (!loading) return;

  /* スクロールロック */
  const lock   = () => { document.body.style.overflow = 'hidden'; };
  const unlock = () => { document.body.style.overflow = ''; };
  lock();

  /* 先頭の MV 動画だけ取得 */
  const mv = document.querySelector('.vegetable_lp1-mv__video video');

  /* ローディング解除共通処理 */
  const finish = () => {
    loading.style.transition = 'opacity .5s';
    loading.style.opacity = '0';
    setTimeout(() => loading.remove(), 500);
    unlock();
    if (mv) mv.play().catch(() => {});
  };

  /* MV が無ければ即解除 */
  if (!mv) { finish(); return; }

  /* 動画属性セット & 読み込み開始 */
  mv.muted = true;
  mv.setAttribute('playsinline', '');
  mv.preload = 'auto';
  mv.load();

  /* バッファ完了判定：canplaythrough 1 回で OK */
  const onReady = () => {
    mv.removeEventListener('canplaythrough', onReady);
    finish();
  };
  mv.addEventListener('canplaythrough', onReady, { once: true });

  /* 15 秒経っても準備できなければ強制解除 */
  setTimeout(finish, 15000);
});


// ================================================
// 100pxスクロールで遅延動画のプリロード開始
// ================================================
document.addEventListener('DOMContentLoaded', () => {
  const lazyVideos = document.querySelectorAll('.lazy-video');
  if (lazyVideos.length === 0) return;

  let hasTriggered = false;

  const handleScroll = () => {
    if (hasTriggered) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop >= 100) {
      hasTriggered = true;
      
      lazyVideos.forEach(video => {
        video.preload = 'auto';
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.load(); // 動画データを読み込み開始
        
        // 動画が読み込まれたら自動再生
        video.addEventListener('canplaythrough', () => {
          video.play().catch(err => {
            console.warn('遅延動画の自動再生エラー:', err);
          });
        }, { once: true });
      });

      // スクロールイベントリスナーを削除
      window.removeEventListener('scroll', handleScroll);
    }
  };

  // スクロールイベントリスナーを追加
  window.addEventListener('scroll', handleScroll);
});
